var map = {
	"./zztbg-1-en.png": "b272",
	"./zztbg-1.png": "c585",
	"./zztbg-2-en.png": "5fee",
	"./zztbg-2.png": "1738",
	"./zztbg-3-en.png": "e369",
	"./zztbg-3.png": "af3c",
	"./zztbg-4-en.png": "b72d",
	"./zztbg-4.png": "b6bd",
	"./zztbg-5-en.png": "c625",
	"./zztbg-5.png": "4794"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3c8";